// extracted by mini-css-extract-plugin
export default {"container":"loan_container__N24g6","text_container":"loan_text_container__bKy3W"};